import { IMutableWidgetsMap, TCommonData, TMutableWidgetsData, TMutableWidgetsOption, TWidget } from '@libs/types';

export const removeWidget = (
    mutableWidgets: IMutableWidgetsMap<TMutableWidgetsData, TMutableWidgetsOption>,
    widgetUid: TWidget<TCommonData>['uid'],
): void => {
    const widget = mutableWidgets[widgetUid];
    if (!widget) return;
    const childUids = widget.widgets;
    delete mutableWidgets[widgetUid];
    if (childUids?.length) {
        for (const uid of childUids) removeWidget(mutableWidgets, uid);
    }
};
